<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
    <path
        d="M17.53,16,6.77,5.19A3.08,3.08,0,0,1,5.9,3,3.12,3.12,0,0,1,6.79.89a3,3,0,0,1,4.29,0L26.13,16l-4.3,4.32L11.08,31.09a3,3,0,0,1-1,.67A3,3,0,0,1,8.92,32a3.13,3.13,0,0,1-1.17-.23A3,3,0,0,1,6.1,30.11a3.06,3.06,0,0,1,0-2.35,3.12,3.12,0,0,1,.66-1Z"
        />
</svg>